export function DragTooltipInvalid() {
  return <>❌</>
}
